import { Box } from 'pcln-design-system'
import React from 'react'
import GptManager from './GptManager'

class GptProcessor extends React.Component {
  componentDidMount() {
    GptManager.getGptInstance((err, googletag) => {
      if (err) {
        console.warn('Error on mount: ', err)
        return
      }

      this.appendCmd(googletag)
      this.mountAd(googletag)
    })
  }

  render() {
    return <Box id={this.props.gptId} />
  }

  addSlotRenderEndedListener(googletag) {
    googletag.pubads().addEventListener('slotRenderEnded', (event = {}) => {
      const idMatchesSlot = event.slot && this.props.gptId === event.slot.getSlotElementId()
      if (idMatchesSlot && event.isEmpty && this.props.onError) {
        this.props.onError()
      }
    })
  }

  appendCmd(googletag) {
    if (typeof googletag?.cmd?.push === 'function') {
      googletag.cmd.push(() => {
        const slot = googletag
          .defineSlot?.(this.props.slot, this.props.sizeMap, this.props.gptId)
          ?.addService?.(googletag.pubads?.())

        if (this.props.targets) {
          Object.keys(this.props.targets).map((key) => slot.setTargeting(key, this.props.targets[key]))
        }

        googletag.pubads?.()?.enableSingleRequest?.()
        googletag.enableServices?.()
        this.addSlotRenderEndedListener(googletag)
      })
    }
  }

  mountAd(googletag) {
    if (googletag?.cmd?.length) {
      googletag.cmd.push(() => {
        googletag?.display?.(this.props.gptId)
      })
    }
  }
}

GptProcessor.displayName = 'GptProcessor'

export default GptProcessor
